import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";

toast.configure();


export const getIncomeAnalyzer = (params,callback) => {
  return (dispatch, getState) => {
  const { user: { token } } = getState();
  ApiClient.get(`${apiUrl}${PORT}/irsIncome`, params,token, dispatch).then((response) => {
    if (response) {
      console.log('response',response)
      dispatch({ type: "INCOME_ANALYZER", data: response });
      return callback(response);
    }else if (response.messageID === 404) {
      toast.error(response.message);
      return callback();
    } else {
      toast.error(response.errors.msg)
    }
  });
}
};

export const mergeIncomeAnalyzer = (params,callback) => {
  return (dispatch, getState) => {
  const { user: { token } } = getState();
  ApiClient.get(`${apiUrl}${PORT}/irsIncome`, params,token, dispatch).then((response) => {
    if (response) {
      console.log('response',response)
      dispatch({ type: "MERGE_INCOME_ANALYZER", data: response });
      return callback(response);
    }else if (response.messageID === 404) {
      toast.error(response.message);
      return callback();
    } else {
      toast.error(response.errors.msg)
    }
  });
}
};

export const resetIncomeAnalyzer = () => {
  return (dispatch, getState) => {
    dispatch({ type: "RESET_INCOME_ANALYZER", data: {} });
  }
};




/**
 * @description function use for to get folder elastic incomeanalyzer 
 * @param {*} params accepting object (loan_number)
 */

 export const getElasticSearchIncomeAnalyzer = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/irsincome/search`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {

          return callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};


export const getIncomeAnalyzerAllPdf = (irsIncomeId,callback) => {
  return (dispatch, getState) => {
  const { user: { token } } = getState();
  ApiClient.get(`${apiUrl}${PORT}/irsIncome/${irsIncomeId}/getIncomeAnalyzerAllPdf`, {},token, dispatch).then((response) => {
    if (response) {
      console.log('response',response)
     // dispatch({ type: "INCOME_ANALYZER", data: response });
      return callback(response);
    }else if (response.messageID === 404) {
      toast.error(response.message);
      return callback();
    } else {
      toast.error(response.errors.msg)
    }
  });
}
};

export const getIncomeAnalyzerCalculationSheet = (irsIncomeId,callback) => {
  return (dispatch, getState) => {
  const { user: { token } } = getState();
  ApiClient.get(`${apiUrl}${PORT}/irsIncome/${irsIncomeId}/getIncomeAnalyzerCalculationSheet`, {},token, dispatch).then((response) => {
    if (response) {
      console.log('response',response)
     // dispatch({ type: "INCOME_ANALYZER", data: response });
      return callback(response);
    }else if (response.messageID === 404) {
      toast.error(response.message);
      return callback();
    } else {
      toast.error(response.errors.msg)
    }
  });
}
};

export const getTaxFormsListing = (callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.get(`${apiUrl}${PORT}/irsIncome/taxFormsListing`, {},token, dispatch).then((response) => {
      if (response) {
        return callback(response);
      }else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg);
        return callback();
      }
    });
  }
};

export const getIncomeStatus = (irsIncomeId, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/irsIncome/${irsIncomeId}/getIncomeStatus`, {}, token, dispatch).then((response) => {
      if (response) {
        return callback(response);
      }else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg);
        return callback();
      }
    });
  }
};


export const getIncomeDocList = (irsIncomeId, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/irsIncome/${irsIncomeId}/getIncomeDocList`, {}, token, dispatch).then((response) => {
      if (response) {
        return callback(response);
      }else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg);
        return callback();
      }
    });
  }
};

export const sendIncomeToLoans = (irsIncomeId, data, callback) => {
  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/irsIncome/${irsIncomeId}/sendIncomeToLoans`, data, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response) {
        return callback(response);
      }else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg);
        return callback();
      }
    });
  }
};


export const incomeLogListing = (irsIncomeId, data, callback) => {
  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const { user: { token } } = getState();
    console.log('icnome log listing dispatch hitting ...')
    ApiClient.post(`${apiUrl}${PORT}/irsIncome/${irsIncomeId}/incomeLogs`, data, token, dispatch).then((response) => {
      dispatch({type: "INCOME_LOGS_LISTING", data: response});
      dispatch({ type: "ISLOADING", data: false });
      if (response) {
        return callback(response);
      }else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg);
        return callback();
      }
    });
  }
};

export const saveUnableToIncomeAnalyzerJsonData = (irsIncomeId, data, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
      ApiClient.post(`${apiUrl}${PORT}/irsIncome/${irsIncomeId}/saveUnableToIncomeAnalyzerJson`, data, token, dispatch).then((response) => { 
        dispatch({ type: "ISLOADING", data: false });
        if (response && response.success == true) {
     
           toast.success(response.msg, toasterConfig);
          callback(response);
        }
          else if (response && response.success == false){
            toast.error(response.msg, toasterConfig);
            callback(response);
          }
         else {
          toast.error(response.errors.msg, toasterConfig);
          return callback();
        }
      });
  }
};


export const updateCompleteStatus = (data, callback) => {
  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const { user: { token } } = getState();
      ApiClient.post(`${apiUrl}${PORT}/irsIncome/updateCompleteStatus`, data, token, dispatch).then((response) => { 
        console.log('sdwewewe')
        dispatch({ type: "ISLOADING", data: false });
        if (response) {
  
          //  toast.success(response.msg, toasterConfig);
          callback(response);
        }
          else if (response && response.success == false){
            toast.error(response.msg, toasterConfig);
            callback(response);
          }
         else {
          toast.error(response?.errors?.msg, toasterConfig);
          return callback();
        }
      });
  }
}

export const saveQAVerification = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    dispatch({ type: "ISLOADING", data:true })
    let url = `${apiUrl}${PORT}/irsIncome/saveQAVerification`
    ApiClient.post(
      url,
      params,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {
        toast.success(response.message)
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
        callback()
      } else {
        toast.error(response.errors.msg, toasterConfig);
        callback()
      }
    });
  };
};

  export const getPendingIRSIncomeDetail = (loan_number,callback) => {
    return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.get(`${apiUrl}${PORT}/irsIncome/getPendingIRSIncomeDetail/${loan_number}`,null,token, dispatch).then((response) => {
      if (response) {
        console.log('response',response)
       // dispatch({ type: "INCOME_ANALYZER", data: response });
        return callback(response);
      }else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg)
      }
    });
  }
  };